module.exports = __webpack_public_path__ + "static/media/DushyanthaSilva.739fa001.png";